// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DialogPanel_wrapper__32dG6"};